import { render, staticRenderFns } from "./PopupViewProfilePersonal.vue?vue&type=template&id=22462aea&scoped=true"
import script from "./PopupViewProfilePersonal.vue?vue&type=script&lang=js"
export * from "./PopupViewProfilePersonal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22462aea",
  null
  
)

export default component.exports